{
  "AUTOMATION": {
    "HEADER": "Automatizáció",
    "DESCRIPTION": "Az automatizálás kiválthatja és egyszerűsítheti a kézi munkát igénylő folyamatokat, például a címkék hozzáadását és a beszélgetések hozzárendelését a legalkalmasabb ügynökhöz. Így a csapat az erősségeire koncentrálhat, és kevesebb időt tölt rutinfeladatokkal.",
    "LEARN_MORE": "Tudjon meg többet az automatizálásról",
    "HEADER_BTN_TXT": "Automatikus szabály hozzáadása",
    "LOADING": "Automatizálási szabályok betöltése",
    "ADD": {
      "TITLE": "Automatikus szabály hozzáadása",
      "SUBMIT": "Létrehozás",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "FORM": {
        "NAME": {
          "LABEL": "Szabály neve",
          "PLACEHOLDER": "Szabálynév megadása",
          "ERROR": "Név kötelező"
        },
        "DESC": {
          "LABEL": "Leírás",
          "PLACEHOLDER": "Szabályleírás megadása",
          "ERROR": "Leírás megadása kötelező"
        },
        "EVENT": {
          "LABEL": "Esemény",
          "PLACEHOLDER": "Kérlek, válassz egyet",
          "ERROR": "Esemény megadása kötezelő"
        },
        "PHASE": {
          "LABEL": "Fázis"
        },
        "ORDER": {
          "LABEL": "Sorrend",
          "ERROR": "A sorrend megadása kötelező"
        },
        "CONDITIONS": {
          "LABEL": "Feltételek"
        },
        "ACTIONS": {
          "LABEL": "Műveletek"
        }
      },
      "CONDITION_BUTTON_LABEL": "Feltétel hozzáadása",
      "ACTION_BUTTON_LABEL": "Akció hozzáadása",
      "API": {
        "SUCCESS_MESSAGE": "Automatizált szabály sikeresen hozzáaadva",
        "ERROR_MESSAGE": "Nem sikerült automatizált szabályt létrehozni. Kérjük, próbáld újra később"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fázis",
        "ORDER": "Sorrend",
        "NAME": "Név",
        "DESCRIPTION": "Leírás",
        "ACTIVE": "Aktív",
        "CREATED_ON": "Létrehozva",
        "WAIT": "Várakozás"
      },
      "404": "Nem található automatizált szabály",
      "TABS": {
        "ALL": "Összes",
        "INSTANT": "Eseménykor",
        "DELAYED": "Késleltetett"
      },
      "WAITS": "Vár: {duration}"
    },
    "DELETE": {
      "TITLE": "Automatizált szabály törlése",
      "SUBMIT": "Törlés",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, Törlés ",
        "NO": "Nem, Mégse "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automatizált szabály sikeresen törölve",
        "ERROR_MESSAGE": "Nem sikerült automatizált szabályt törölni. Kérjük, próbáld újra később"
      }
    },
    "EDIT": {
      "TITLE": "Automatizált szabály szerkesztése",
      "SUBMIT": "Frissítés",
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "SUCCESS_MESSAGE": "Automatizált szabály sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült automatizált szabályt frissíteni. Kérjük, próbáld újra később"
      }
    },
    "CLONE": {
      "TOOLTIP": "Duplikálás",
      "API": {
        "SUCCESS_MESSAGE": "Automatizálás sikeresen többszörözve",
        "ERROR_MESSAGE": "Nem sikerült automatizált szabályt többszörözni. Kérjük, próbáld újra később"
      }
    },
    "FORM": {
      "EDIT": "Szerkesztés",
      "CREATE": "Létrehozás",
      "DELETE": "Törlés",
      "CANCEL": "Mégse",
      "RESET_MESSAGE": "Az eseménytípus módosítása visszaállítja az alább hozzáadott feltételeket és eseményeket\n"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Legalább egy feltételt meg kell adnod a mentéshez",
      "CONTACT_CUSTOM_ATTR_LABEL": "Kapcsolat az egyéni tulajdonságokkal",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Beszélgetés az egyéni tulajdonságokkal\n"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Legalább egy tevékenység szükséges a mentéshez",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Írd be az üzeneted ide",
      "TEAM_DROPDOWN_PLACEHOLDER": "Csapatok kiválasztása",
      "EMAIL_INPUT_PLACEHOLDER": "Adja meg az e-mail-címet",
      "URL_INPUT_PLACEHOLDER": "Adja meg az URL-t",
      "SENDER_DROPDOWN_PLACEHOLDER": "Válassz e-mail postafiókot és feladó címet",
      "SUBJECT_INPUT_PLACEHOLDER": "E-mail tárgya",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Válaszd ki az SMS postafiókot, amelyből küldeni szeretnél",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Add meg az SMS szövegét",
      "SMS_COUNTER": "{length}/{limit} karakter, {segments} SMS (a változók behelyettesítése előtt)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Automatizált szabályok aktivizálása",
      "DEACTIVATION_TITLE": "Automatizált szabályok inaktivizálása",
      "ACTIVATION_DESCRIPTION": "Ez a művelet aktiválja a „{automationName}” automatizálási szabályt. Biztosan folytatod?",
      "DEACTIVATION_DESCRIPTION": "Ez a művelet deaktiválja a(z) „{automationName}” automatizálási szabályt. Biztosan folytatod?",
      "ACTIVATION_SUCCESFUL": "Automatizált szabály sikeresen aktiválva",
      "DEACTIVATION_SUCCESFUL": "Automatizált szabály sikeresen inaktiválva",
      "ACTIVATION_ERROR": "Nem sikerült aktiválni az automatizálást. Kérjük, próbálja újra később",
      "DEACTIVATION_ERROR": "Nem sikerült inaktiválni az automatizálást. Kérjük, próbálja újra később",
      "CONFIRMATION_LABEL": "Igen",
      "CANCEL_LABEL": "Nem"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Nem sikerült feltölteni a csatolmányt, kérlek, próbáld később",
      "LABEL_IDLE": "Csatolmányok feltöltése",
      "LABEL_UPLOADING": "Frissítés...",
      "LABEL_UPLOADED": "Sikeres feltöltés",
      "LABEL_UPLOAD_FAILED": "Sikertelen feltöltés"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "A tulajdonság kulcsa kötelező",
      "FILTER_OPERATOR_REQUIRED": "A szűrő operátora kötelező",
      "VALUE_REQUIRED": "Kötelező megadni",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Az értéknek 0 és 998 között kell lennie",
      "ACTION_PARAMETERS_REQUIRED": "A művelet paraméterei kötelezők",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Legalább egy feltétel megadása kötelező",
      "ATLEAST_ONE_ACTION_REQUIRED": "Legalább egy művelet megadása kötelező",
      "ORDER_REQUIRED": "A sorrend megadása kötelező",
      "ORDER_MUST_BE_AT_LEAST_ONE": "A sorrendnek legalább 1-nek kell lennie",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ez a művelet csak akkor működik, ha a szabály fázisa a 'Címkézés előtt' értékre van állítva.",
      "SKIP_AUTO_LABELING": "Ez a művelet csak akkor működik, ha a szabály fázisa a 'Címkézés előtt' értékre van állítva.",
      "MOVE_CONVERSATION_TO_INBOX": "E-mail postafiókba csak e-mailes és webes csevegésből származó beszélgetések helyezhetők át, a webes csevegés csak akkor, ha a kapcsolattartónak van e-mail-címe. Egyébként a beszélgetés a helyén marad, és helyette egy privát üzenet kerül hozzáadásra.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Új beszélgetést indít a kapcsolattartóval a kiválasztott e-mail postafiókban, e-mailben elküldi neki az üzenetet, és megoldottnak jelöli a beszélgetést. Ez a szabály minden futásakor megtörténik. Ha a kapcsolattartónak nincs e-mail-címe, semmi sem kerül elküldésre, helyette privát jegyzet jön létre.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Új beszélgetést indít a kapcsolattartóval a kiválasztott SMS postafiókban, SMS-ben elküldi neki az üzenetet, és megoldottnak jelöli a beszélgetést. Ez a szabály minden futásakor megtörténik. Az üzenet egyszerű szöveg, mellékletek nélkül. Ha a kapcsolattartónak nincs telefonszáma, semmi sem kerül elküldésre, helyette privát jegyzet jön létre."
    },
    "NOTICES": {
      "AI_PROMPT": "Minden egyes kiértékelés díjköteles.",
      "INCOMING_MESSAGES_COUNT": "Ez a beszélgetésben lévő bejövő üzenetek számára utal.",
      "OUTGOING_MESSAGES_COUNT": "Ez a beszélgetésben lévő kimenő üzenetek számára utal."
    },
    "PHASE": {
      "BEFORE_LABELING": "Címkézés előtt",
      "AFTER_LABELING": "Címkézés után"
    },
    "NONE_OPTION": "Nincs",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Bejövő üzenet",
      "OUTGOING": "Kimenő üzenet",
      "PRIVATE": "Privát jegyzet",
      "AI_SUMMARY": "AI-összegzés"
    },
    "YES_NO_VALUES": {
      "YES": "Igen",
      "NO": "Nem"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram közvetlen üzenet",
      "FACEBOOK_COMMENT": "Facebook-hozzászólás"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Beszélgetés létrehozva",
      "CONVERSATION_UPDATED": "Beszélgetés frissítve",
      "MESSAGE_CREATED": "Üzenet létrehozva",
      "CONVERSATION_OPENED": "Beszélgetés megnyitva",
      "CONVERSATION_RESOLVED": "Beszélgetés megoldva",
      "PHONE_CALL_FINISHED": "Hívás befejezve"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Ügynökhöz rendelés",
      "ASSIGN_TEAM": "Csapathoz rendelés",
      "ADD_LABEL": "Címke hozzáadása",
      "REMOVE_LABEL": "Címke eltávolítása",
      "SEND_EMAIL_TO_TEAM": "E-mail küldése a csapatnak",
      "SEND_EMAIL_TRANSCRIPT": "E-mail átirat küldése",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Részletes e-mail átirat küldése",
      "MUTE_CONVERSATION": "Beszélgetés némítása",
      "SNOOZE_CONVERSATION": "Beszélgetés halasztása",
      "RESOLVE_CONVERSATION": "Beszélgetés lezárása",
      "OPEN_CONVERSATION": "Beszélgetés megnyitása",
      "SEND_WEBHOOK_EVENT": "Webhook esemény küldése",
      "SEND_ATTACHMENT": "Melléklet küldése",
      "SEND_MESSAGE": "Üzenet küldése",
      "ADD_NOTE": "Jegyzet hozzáadása",
      "CHANGE_PRIORITY": "Prioritás módosítása",
      "ADD_SLA": "SLA hozzáadása",
      "SKIP_AUTO_PRIORITY": "Automatikus prioritás kihagyása",
      "SKIP_AUTO_LABELING": "Automatikus címkézés kihagyása",
      "AUTO_TRANSLATE": "Üzenet lefordítása",
      "AUTO_TRANSLATE_CONVERSATION": "Beszélgetés lefordítása",
      "MOVE_CONVERSATION_TO_INBOX": "Beszélgetés áthelyezése postafiókba",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Üzenet küldése új beszélgetésben",
      "SEND_SMS_IN_NEW_CONVERSATION": "SMS küldése új beszélgetésben",
      "STOP_PROCESSING_RULES": "Szabályok feldolgozásának leállítása"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Hívott mellék",
      "WORKING_HOURS": "Munkaidőn belül",
      "AGENT_REPLIED": "Az ügynök válaszolt az állapotváltozás óta",
      "AI_FILTER": "AI szűrő",
      "MESSAGE_TYPE": "Üzenet típusa",
      "MESSAGE_CONTAINS": "Üzenet tartalma",
      "EMAIL": "Kapcsolattartó e-mail-címe",
      "INBOX": "Postafiók",
      "CHANNEL_TYPE": "Postafiók típusa",
      "CONVERSATION_LANGUAGE": "Beszélgetés nyelve",
      "PHONE_NUMBER": "Telefonszám",
      "STATUS": "Állapot",
      "BROWSER_LANGUAGE": "Böngésző nyelve",
      "MAIL_SUBJECT": "E-mail tárgya",
      "COUNTRY_NAME": "Ország",
      "MARKETPLACE_COUNTRY": "Marketplace országa",
      "REFERER_LINK": "Hivatkozó link",
      "ASSIGNEE_NAME": "Hozzárendelt",
      "TEAM_NAME": "Csapat",
      "PRIORITY": "Prioritás",
      "CALL_DIRECTION": "Hívás iránya",
      "MISSED_CALL": "Nem fogadott hívás",
      "MISSED_CALL_COUNT": "Nem fogadott hívások száma",
      "MESSAGE_SOURCE_TYPE": "Üzenet forrásának típusa",
      "INCOMING_MESSAGE_COUNT": "Bejövő üzenetek száma",
      "OUTGOING_MESSAGE_COUNT": "Kimenő üzenetek száma",
      "LABEL": "Címke",
      "EMAIL_RECIPIENTS": "E-mail címzett",
      "EMAIL_AUTO_REPLY": "Az e-mail automatikus válasz",
      "ATTACHMENT_EXTENSION": "Melléklet kiterjesztése"
    },
    "WAIT": {
      "RUN_LABEL": "Műveletek futtatása",
      "INSTANT": "Eseménykor",
      "DELAYED": "Késleltetve",
      "TRIGGER_LABEL": "Várakozás, amíg",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Egy beszélgetés egy állapotban marad",
        "CUSTOMER_UNRESPONSIVE": "Az ügyfél nem válaszol egy ügynöknek",
        "AGENT_UNRESPONSIVE": "Az ügyfél nem kap választ egy ügynöktől"
      },
      "STATUS_LABEL": "Állapot",
      "STATUSES": {
        "OPEN": "Nyitott",
        "PENDING": "Függőben",
        "SNOOZED": "Elhalasztott",
        "RESOLVED": "Megoldott"
      },
      "DELAY_LABEL": "Várakozási idő",
      "DELAY_ERROR": "Adjon meg 1 perc és 30 nap közötti várakozási időt",
      "DURATION": {
        "MINUTES": "{count} perc",
        "HOURS": "{count} óra",
        "DAYS": "{count} nap"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "A műveletek akkor futnak, ha egy beszélgetés {duration} óta {status} állapotú. Az előtte történő állapotváltozás törli őket. A címkéket, a munkaidőt és az ügynöki válaszokat a várakozás lejártakor ellenőrzi a rendszer.",
        "CUSTOMER_UNRESPONSIVE": "A műveletek akkor futnak, ha az ügyfél {duration} óta nem válaszolt egy ügynök üzenetére. Az ügyfél válasza törli őket; az ügynök új üzenete újraindítja a várakozást.",
        "AGENT_UNRESPONSIVE": "A műveletek akkor futnak, ha az ügyfél {duration} óta ügynöki válasz nélkül vár. Az ügynök válasza törli őket."
      }
    }
  }
}
